import { Router } from '@angular/router';
import { HttpResponse } from 'selenium-webdriver/http';
import { environment } from './../../environments/environment';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { CookieService } from 'angular2-cookie/services/cookies.service';

import { Injectable } from '@angular/core';

@Injectable()
export class AuthenticationService {
    token: string;

    baseUrlLogin = environment.baseUrlLogin;


    constructor(private httpClient: HttpClient, private cookieService: CookieService,public router:Router) { }

    loginApi(email: string, password: string) {
        const body = new HttpParams()
            .set('email', email)
            .set('password', password);
        return this.httpClient.post(this.baseUrlLogin + '/login',
            body.toString(),
            {
                headers: new HttpHeaders()
                    .set('Content-Type', 'application/x-www-form-urlencoded')
            }
        )

    }

    setAccessToken(token: string) {
        this.cookieService.put('token_id', token)
    }

    setUserId(id: string) {
        this.cookieService.put('user_id', id)
    }

    getAccessToken() {
        return this.cookieService.get('token_id');
    }

    getUserId() {
        return this.cookieService.get('user_id');
    }

    public isAuthenticated(): any {
        const token = this.getAccessToken();
        if (token)
            return true
        else
            return false
    }


    userLogout() {
        this.cookieService.removeAll();
        this.router.navigate(['/login']);
    }
}



// WEBPACK FOOTER //
// /Users/igor/Projects/onechat/admin-dashboard/src/app/authentication/authentication.service.ts